'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateDoubleIcon = function TemplateDoubleIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 26.3 21.6' }, props),
        _react2.default.createElement('path', { 'class': 'st0', d: 'M21.8 2.1h-20C.9 2.1.1 2.7 0 3.7v16.4c.1.9.9 1.6 1.8 1.5h19.9c.9.1 1.7-.6 1.8-1.5V3.7c0-1-.8-1.7-1.7-1.6zm1.1 18c0 .6-.5 1-1.1.9h-20c-.5.1-1-.3-1.1-.9V3.7c0-.6.5-1 1.1-.9h19.9c.5-.1 1 .3 1.1.9v16.4z' }),
        _react2.default.createElement('path', { 'class': 'st0', d: 'M2.6 4c-.4 0-.7.3-.7.7v1.5h.7V4.7h1.8V4H2.6zM19.5 5.8H4.1c-.2 0-.4.2-.4.4v4.4c0 .2.1.4.3.4h15.5c.2 0 .4-.2.4-.3V6.2c0-.2-.1-.4-.4-.4.1 0 0 0 0 0zm-.3 4.4H4.4V6.6h14.8v3.6zM9.6 12.1H4c-.2 0-.3.1-.3.3V18c0 .2.1.3.3.4h5.6c.2 0 .4-.1.4-.3v-5.6c0-.2-.1-.4-.4-.4.1 0 0 0 0 0zm-5.2 5.6v-4.4l4.4 4.4H4.4zm4.9-.5l-4.4-4.4h4.4v4.4zM11.1 12.8h8.8v.7h-8.8zM12.5 14.5H20v.9h-7.5zM11.5 16.9h1v1h-1zM13.5 16.9h1v1h-1zM5.5.8L5.2.5c.1-.1.3-.2.5-.3l.2.5c-.2 0-.3 0-.4.1zM25.8 17.9l-.4-.4c.2-.2.3-.4.3-.7h.5c0 .5-.2.8-.4 1.1zm.4-2h-.5v-1h.5v1zm0-2h-.5v-1h.5v1zm0-2h-.5v-1h.5v1zm0-1.9h-.5V9h.5v1zm0-2h-.5V7h.5v1zm0-1.9h-.5v-1h.5v1zm0-2h-.5v-1h.5v1zm0-2h-.5v-.4c0-.1 0-.3-.1-.4l.5-.2c.1.2.1.4.1.6v.4zm-1-1.4c-.2-.1-.4-.2-.6-.2h-.3V0h.3c.3 0 .6.1.8.2l-.2.5zM23.4.5h-1V0h1v.5zm-2 0h-1V0h1v.5zm-1.9 0h-1V0h1v.5zm-2 0h-1V0h1v.5zm-2 0h-1V0h1v.5zm-1.9 0h-1V0h1v.5zm-2 0h-1V0h1v.5zm-2 0h-1V0h1v.5zM7.7.5h-1V0h1v.5zM24.2 17.8h.5v.5h-.5z' })
    );
};

exports.default = TemplateDoubleIcon;